import {
  RESET_UPDATE_MENU_DATA,
  UPDATE_MENU_DATA_ERROR,
  UPDATE_MENU_DATA_LOADING,
  UPDATE_MENU_DATA_SUCCESS,
} from "../type/Constant";

let initialState = {
  error: false,
  success: false,
  loading: false,
  errors: [],
};

export default function editMenuReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_MENU_DATA_LOADING:
      return { ...state, error: false, loading: true, success: false };
    case UPDATE_MENU_DATA_SUCCESS:
      return {
        ...state,
        error: false,
        success: true,
        loading: false,
        message: action.msg,
      };
    case UPDATE_MENU_DATA_ERROR:
      return { ...state, error: true, success: false, loading: false };
    case RESET_UPDATE_MENU_DATA:
      return {
        ...state,
        error: false,
        success: false,
        loading: false,
        errors: [],
      };
    default:
      return state;
  }
}
